import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function SubscriptionSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6 text-center">
      <div className="w-full max-w-lg rounded-xl bg-white p-8 shadow-xl">
        <div className="mx-auto mb-5 grid h-16 w-16 place-items-center rounded-full bg-green-100 text-3xl text-green-600">✓</div>
        <h1 className="text-3xl font-bold text-slate-800">Subscription checkout complete</h1>
        <p className="mt-4 text-slate-600">Your subscription is being confirmed by Stripe. Your plan and entitlements will appear in Billing shortly.</p>
        {sessionId && <p className="mt-4 break-all text-xs text-slate-400">Checkout session: {sessionId}</p>}
        <Link to="/dashboard/billing" className="mt-8 inline-block rounded-lg bg-indigo-600 px-6 py-3 font-semibold text-white hover:bg-indigo-700">Open Billing</Link>
      </div>
    </div>
  );
}
